'use strict';
angular
    .module('dnapp')
    .factory('DNDepartments.ResetUmbracoPasswordService', ['$resource', function ($resource) {
        return $resource('/umbraco/backend/ResetUmbracoPasswordApi/:action', {}, {
            resetPassword: { method: "POST", params: { action: "ResetPassword" } },
            checkGuid: { method: "POST", params: { action: "CheckGuid" } },
            setNewPassword: { method: "POST", params: { action: "SetNewPassword" } },
        });
    }]);